import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../Auth/AuthProvider';
import { useBrotiaChat } from '../providers/BrotiaChatProvider';
import SupportChat from './SupportChat';

const BROTIA_PURPLE = '#6347c5';

const SupportWidget: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { unreadCount } = useBrotiaChat();
  const [isOpen, setIsOpen] = useState(false);

  // Only visible to signed-in merchants; the provider gates the session too.
  if (!user) return null;

  return (
    // Pinned to the bottom-right corner.
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end">
      {isOpen && (
        <div className="mb-3 flex h-[560px] max-h-[80vh] w-[380px] max-w-[calc(100vw-2.5rem)] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/10">
          <div
            className="flex items-center justify-between px-4 py-3 text-white"
            style={{ backgroundColor: BROTIA_PURPLE }}
          >
            <span className="text-sm font-bold">{t('supportChatTitle')}</span>
            <button
              type="button"
              aria-label={t('close')}
              onClick={() => setIsOpen(false)}
              className="text-2xl leading-none text-white/90 hover:text-white"
            >
              &times;
            </button>
          </div>
          <div className="min-h-0 flex-1">
            <SupportChat />
          </div>
        </div>
      )}

      <button
        type="button"
        aria-label={t('supportChatTitle')}
        onClick={() => setIsOpen((v) => !v)}
        className="relative flex h-14 w-14 items-center justify-center rounded-full text-2xl text-white shadow-lg transition-transform hover:scale-105"
        style={{ backgroundColor: BROTIA_PURPLE }}
      >
        {isOpen ? '⌄' : '💬'}
        {!isOpen && unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-xs font-bold text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default SupportWidget;
